// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.client.renterrole.dto.RenterRoleType

export enum RenterRoleType {
  TENANT = 'TENANT',
}

export const RenterRoleType_values = [RenterRoleType.TENANT] as const;
